/*eslint-disable no-unused-vars*/
import React from 'react';
import latinize from "latinize";
/*eslint-enable no-unused-vars*/
function stringSanitizer(string) {
  // Handle umlauts.
  latinize.characters['ø'] = 'o'
  latinize.characters['å'] = 'a'
  latinize.characters['æ'] = 'ae'
  string = latinize(string)

  // Remove any symbols and special characters.
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 -]+/g, '')
    .replace(/[ -]+/g, '-');
}
export default stringSanitizer;
